module.exports = __webpack_public_path__ + "img/9_95.ec8adc9d.png";